import { useState } from "react";
import { selectCommunicationData } from "../../store";
import { saveCommunicationAct } from "../../store/communication-data/actions";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { FileSideEnum, LinearFileTypeEnum } from "../../types/commonTypes";
import { CommunicationType, FileItemType, FronteRetroFileItemType } from "../../types/communication/communicationDataType";
import { FileItemContainer, FileItemTitle, FileMultiContainer } from "../styled/File.style";
import FilesUploadListCmp from "./FilesUploadListCmp";
import styled from "styled-components";

const SeparatorLine = styled.div<{ $adaptingDoubleLine?: boolean }>`
    width: ${({ $adaptingDoubleLine }) => $adaptingDoubleLine ? '100%' : '1px'};
    height: ${({ $adaptingDoubleLine }) => $adaptingDoubleLine ? '1px' : 'auto'};
    background-color: #D6D6D6;
    align-self: center;
`;

interface FronteRetroFilesUploadListCmpProps {
    initFronteRetroObj: FronteRetroFileItemType
    arrayDbPropSync: string
    fileTypeFront: LinearFileTypeEnum | string
    fileTypeRear: LinearFileTypeEnum | string
    alreadySentDocIds?: string[]
    customUpdateDbCommunicationFileList?: any,
    textLabelFront?: string,
    textLabelRear?: string,
    adaptingDoubleLine?: boolean,
    onPreUploadCallback?: (file: File) => boolean;
}

/* istanbul ignore next */
export const FronteRetroFilesUploadListCmp = (props: FronteRetroFilesUploadListCmpProps) => {
    const dispatch = useAppDispatch();
    const communicationData = useAppSelector(selectCommunicationData)
    const { communication }: any = communicationData
    const { adaptingDoubleLine, initFronteRetroObj, arrayDbPropSync, fileTypeFront, fileTypeRear, alreadySentDocIds, customUpdateDbCommunicationFileList, textLabelFront, textLabelRear, onPreUploadCallback } = props

    const [front, setFront] = useState<FileItemType[]>(initFronteRetroObj?.front || [])
    const [rear, setRear] = useState<FileItemType[]>(initFronteRetroObj?.retro || [])

    const updateDbCommunicationFileList = (newFileList: FileItemType[], fileSideEnum: FileSideEnum) => {
        if (customUpdateDbCommunicationFileList) {
            customUpdateDbCommunicationFileList(newFileList, fileSideEnum)
        } else if (arrayDbPropSync) {
            const updComm: any = new CommunicationType(communication)

            if (updComm[arrayDbPropSync]) {
                updComm[arrayDbPropSync][fileSideEnum] = newFileList

                dispatch(saveCommunicationAct({
                    data: updComm
                })
                )
            }
        }
    }

    return (
        <>
            <FileMultiContainer $adaptingDoubleLine={adaptingDoubleLine}>
                <FileItemContainer>
                    <FileItemTitle>Fronte</FileItemTitle>
                    <FilesUploadListCmp
                        files={front}
                        setFiles={setFront}
                        fileType={fileTypeFront}
                        arrayDbPropSync={arrayDbPropSync}
                        customUpdateDbCommunicationFileList={(newFiles: FileItemType[]) => updateDbCommunicationFileList(newFiles, FileSideEnum.FRONT)}
                        companyName={communication?.companyName}
                        maxLimit={1}
                        alreadySentDocIds={alreadySentDocIds}
                        isInMultiCard={true}
                        onPreUploadCallback={onPreUploadCallback}
                        textLabel={textLabelFront}
                    />
                </FileItemContainer>

                {adaptingDoubleLine && <SeparatorLine $adaptingDoubleLine={adaptingDoubleLine} />}

                <FileItemContainer>
                    <FileItemTitle>Retro</FileItemTitle>
                    <FilesUploadListCmp
                        files={rear}
                        setFiles={setRear}
                        fileType={fileTypeRear}
                        arrayDbPropSync={arrayDbPropSync}
                        customUpdateDbCommunicationFileList={(newFiles: FileItemType[]) => updateDbCommunicationFileList(newFiles, FileSideEnum.RETRO)}
                        companyName={communication?.companyName}
                        maxLimit={1}
                        alreadySentDocIds={alreadySentDocIds}
                        isInMultiCard={true}
                        onPreUploadCallback={onPreUploadCallback}
                        textLabel={textLabelRear}
                    />
                </FileItemContainer>
            </FileMultiContainer>
        </>
    )
}

export default FronteRetroFilesUploadListCmp